import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    numberCircleInline: {
      borderRadius: '50%',
      marginLeft: '30px',
      marginBottom: '28px',
      width: '30px',
      height: '30px',
      background: '#3C419A',
      color: '#FFFFFF',
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      lineHeight: '14px',
      display: 'inline-block',
      alignContent: 'center',
    },
    numbersInCirclesInline: {
      fontSize: 12,
      fontFamily: 'Roboto',
      color: '#FFFFF',
      marginTop: '8px',
      left: '63px',
      display: 'inline-block',
    },
    numberCircleOutline: {
      position: 'relative',
      borderRadius: '50%',
      left: '12px',
      marginBottom: '28px',
      width: '28px',
      height: '28px',
      border: '1px solid #3C419A',
      background: '#FFFFF',
      color: '#3C419A',
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      lineHeight: '14px',
      display: 'inline-block',
      alignContent: 'center',
    },
    numbersInCirclesOutline: {
      fontSize: 12,
      fontFamily: 'Roboto',
      color: '#FFFFF',
      marginTop: '8px',
      display: 'inline-block',
    },
    textInline: {
      marginLeft: '10px',
      fontSize: '13px',
      fontFamily: 'Roboto',
      color: '#2C2D3E',
      display: 'inline-block',
      fontWeight: 'bold',
    },
    textOutline: {
      position: 'relative',
      left: '20px',
      fontSize: '13px',
      fontFamily: 'Roboto',
      color: '#2C2D3E',
      display: 'inline-block',
    },
    line: {
      position: 'relative',
      left: '7px',
      top: '8px',
      width: '110px',
      size: '0px',
      color: '#2c2d3e',
      opacity: 0.3,
      display: 'inline-block',
      align: 'center',
    },
  }),
);
